module.exports = __webpack_public_path__ + "static/media/infinity-white-icon.b5ebf6d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infinity-white-icon.svg
// module id = 156
// module chunks = 0